import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom"; // For navigation
import TableToExcel from "./helpers/Excel";
import { getFormattedDate } from "./helpers/functions";

const Filled = () => {
    const [data, setData] = useState([]);
    const [excel, setExcel] = useState([]);

    useEffect(() => {

        axios.post("api/getteachersdatafilledfull")
            .then((res) => {
                setExcel(res.data.rows);
                console.log(res.data.rows)
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        axios.post("api/getteachersdatafilled")
            .then((res) => {
                setData(res.data.rows);
                console.log(res.data.rows)
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);


    // Function to extract specific columns from the data
    const extractSpecificColumns = (data) => {
        return data.map((row) => {
            const { MosName, Semel, ty, Gender,identifier, first_name, last_name, phone, mail } = row;
            return {
                "שם מוסד": MosName,
                "סמל": Semel,
                "עיר": ty,
                "מין": Gender,
                "מזהה": identifier,
                "שם": first_name,
                "משפחה": last_name,
                "טל": phone,
                "מייל": mail,
            };
        });
    };

    let specificColumnsData = extractSpecificColumns(excel);

    return (
        <>
            <Container className='text-center'>
                <h3 className='pt-2'>
                    מוסדות שסיימו
                </h3>
                <hr />
                <Row className='mb-1'>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} >
                        <TableToExcel data={specificColumnsData} fileName={`data_${getFormattedDate()}`} />
                    </Col>
                </Row>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>שם מוסד</th>
                            <th>סמל</th>
                            <th>עיר</th>
                            <th>מין</th>
                            <th>מנהל</th>
                            <th>טל</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td><Link to={"/teachersdata?semel=" + row.Semel}>{row.MosName}</Link></td>
                                    <td>{row.Semel}</td>
                                    <td>{row.ty}</td>
                                    <td>{row.Gender}</td>
                                    <td>{row.Principal}</td>
                                    <td>{row.Ptel}</td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </Table>
            </Container>
        </>
    );
};

export default Filled;
